import { render, staticRenderFns } from "./BaseSupporters.vue?vue&type=template&id=1027a6f4&scoped=true&"
import script from "./BaseSupporters.vue?vue&type=script&lang=js&"
export * from "./BaseSupporters.vue?vue&type=script&lang=js&"
import style0 from "./BaseSupporters.vue?vue&type=style&index=0&id=1027a6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027a6f4",
  null
  
)

export default component.exports